import { useState } from "react";
import { TabPage } from "../../../components";
import styles from "./styles.module.css";
import classNames from "classnames";
import AwaitingDispatchTable from "./AwaitingDispatchTable";

const AwaitingDispatch = () => {
  const [currentTab, setCurrentTab] = useState(1);

  return (
    <TabPage pageTitle="Transcript Management/ Awaiting Dispatch">
      <div className={styles.tab_container}>
        <div
          className={classNames(
            styles.tab_item,
            currentTab === 1 && styles.active
          )}
          onClick={() => setCurrentTab(1)}
        >
          Transcripts
        </div>
        <div
          className={classNames(
            styles.tab_item,
            currentTab === 2 && styles.active
          )}
          onClick={() => setCurrentTab(2)}
        >
          Proficiency
        </div>
        <div
          className={classNames(
            styles.tab_item,
            currentTab === 3 && styles.active
          )}
          onClick={() => setCurrentTab(3)}
        >
          Post Graduate
        </div>
        <div
          className={classNames(
            styles.tab_item,
            currentTab === 4 && styles.active
          )}
          onClick={() => setCurrentTab(4)}
        >
          NCE
        </div>
      </div>
      {currentTab === 1 && <AwaitingDispatchTable requestType={1} />}
      {currentTab === 2 && <AwaitingDispatchTable requestType={2} />}
      {currentTab === 3 && <AwaitingDispatchTable requestType={3} />}
      {currentTab === 4 && <AwaitingDispatchTable requestType={4} />}
    </TabPage>
  );
};
export default AwaitingDispatch;
